'use strict';

var _defineProperty = require("/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/defineProperty.js");
var _classCallCheck = require("/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Node = require('./node');
var Declaration = /*#__PURE__*/function (_Node) {
  _inherits(Declaration, _Node);
  var _super = _createSuper(Declaration);
  function Declaration(defaults) {
    var _this;
    _classCallCheck(this, Declaration);
    if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') {
      defaults = _objectSpread(_objectSpread({}, defaults), {}, {
        value: String(defaults.value)
      });
    }
    _this = _super.call(this, defaults);
    _this.type = 'decl';
    return _this;
  }
  _createClass(Declaration, [{
    key: "variable",
    get: function get() {
      return this.prop.startsWith('--') || this.prop[0] === '$';
    }
  }]);
  return Declaration;
}(Node);
module.exports = Declaration;
Declaration.default = Declaration;